import { render, staticRenderFns } from "./AddLessonsToCourseModal.vue?vue&type=template&id=6fc627b6&scoped=true&"
import script from "./AddLessonsToCourseModal.vue?vue&type=script&lang=ts&"
export * from "./AddLessonsToCourseModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddLessonsToCourseModal.vue?vue&type=style&index=0&id=6fc627b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc627b6",
  null
  
)

export default component.exports